import { deleteGame, savePrevGame } from "../actions";

export const handleExitGame = (confirm, dispatch) => {
  confirm({
    description: "Game progress will be lost",
    confirmationButtonProps: { autoFocus: true },
  }).then(() => {
    if (
      ![
        "http://localhost:3000/",
        "https://geogames-dpocsai.netlify.app/",
      ].includes(window.location.href)
    ) {
      dispatch(deleteGame());
      dispatch(savePrevGame(null));
    }
  });
};
